import { render, staticRenderFns } from "./BubbleIcon.vue?vue&type=template&id=8bfcd258&scoped=true&"
import script from "./BubbleIcon.vue?vue&type=script&lang=ts&"
export * from "./BubbleIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BubbleIcon.vue?vue&type=style&index=0&id=8bfcd258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfcd258",
  null
  
)

export default component.exports